import React from "react";
import { TCustomer } from "../../../../types/Types";
import {
  DevicePhoneMobileIcon,
  CheckBadgeIcon,
  XCircleIcon,
} from "@heroicons/react/24/outline";

interface AdminControlsProps {
  customer: TCustomer;
  onClearSessions: () => void;
  onToggleDisable: () => void;
}

const AdminControls = ({
  customer,
  onClearSessions,
  onToggleDisable,
}: AdminControlsProps) => {
  return (
    <div className="bg-gray-900 border border-gray-800 rounded-3xl p-6 shadow-xl overflow-hidden relative group">
      <div className="absolute top-0 right-0 -mr-8 -mt-8 w-32 h-32 bg-primary/20 rounded-full blur-3xl" />
      <h2 className="text-lg font-bold text-white mb-6 relative">
        Admin Controls
      </h2>
      <div className="space-y-3 relative">
        <button
          onClick={onClearSessions}
          className="w-full flex items-center justify-between p-4 bg-white/5 hover:bg-white/10 rounded-2xl transition-all group"
        >
          <div className="flex items-center gap-3">
            <div className="p-2 bg-white/10 rounded-xl">
              <DevicePhoneMobileIcon className="w-5 h-5 text-white" />
            </div>
            <div className="text-left">
              <p className="text-sm font-bold text-white">Clear Sessions</p>
              <p className="text-[10px] text-gray-400">
                Force logout from all devices
              </p>
            </div>
          </div>
        </button>

        <button
          onClick={onToggleDisable}
          className={`w-full flex items-center justify-between p-4 rounded-2xl transition-all ${
            customer.disabled
              ? "bg-green-500/10 hover:bg-green-500/20 text-green-500"
              : "bg-red-500/10 hover:bg-red-500/20 text-red-500"
          }`}
        >
          <div className="flex items-center gap-3">
            <div
              className={`p-2 rounded-xl ${customer.disabled ? "bg-green-500/20" : "bg-red-500/20"}`}
            >
              {customer.disabled ? (
                <CheckBadgeIcon className="w-5 h-5" />
              ) : (
                <XCircleIcon className="w-5 h-5" />
              )}
            </div>
            <div className="text-left">
              <p className="text-sm font-bold">
                {customer.disabled ? "Enable Account" : "Disable Account"}
              </p>
              <p
                className={`text-[10px] ${customer.disabled ? "text-green-500/60" : "text-red-500/60"}`}
              >
                {customer.disabled
                  ? "Allow user to login"
                  : "Temporary block access"}
              </p>
            </div>
          </div>
        </button>
      </div>
    </div>
  );
};

export default AdminControls;
